enum GoogleScopeEnum {
  GmailModify = "https://www.googleapis.com/auth/gmail.modify",
  GmailCompose = "https://www.googleapis.com/auth/gmail.compose",
  GmailSend = "https://www.googleapis.com/auth/gmail.send",
  Calendar = "https://www.googleapis.com/auth/calendar",
}
export default GoogleScopeEnum;
